import React, { useEffect, useRef } from 'react';
import { Modal, Spin } from 'antd';

type TourVideoModalProps = {
  open: boolean;
  onClose: () => void;
  videoSrc: string;
  title?: string;
};

const TourVideoModal: React.FC<TourVideoModalProps> = ({
  open,
  onClose,
  videoSrc,
  title = 'Product tour',
}) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => {
      try {
        videoRef.current?.pause();
        if (videoRef.current) videoRef.current.currentTime = 0;
      } catch {
        //ignore
      }
    }, 0);
    return () => clearTimeout(t);
  }, [open]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.8)' }}
      centered
      title={title}
      destroyOnClose
      maskClosable
      keyboard
      width={860}
      className='tourVideoModal'
    >
      <div className='tourVideoModal__wrap'>
        {!videoSrc ? (
          <div className='tourVideoModal__loading'>
            <Spin />
          </div>
        ) : (
          <video
            ref={videoRef}
            controls
            autoPlay
            muted
            playsInline
            preload='auto'
            style={{ width: '100%', borderRadius: 12 }}
          >
            <source src={videoSrc} type='video/mp4' />
            Your browser does not support the video tag.
          </video>
        )}
      </div>
    </Modal>
  );
};

export default TourVideoModal;
